import api from './api';
import { GoFrugalLogResponse, GoFrugalLogSource } from '../types/gofrugalLog';

export const getGoFrugalLogs = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    source?: GoFrugalLogSource;
}): Promise<GoFrugalLogResponse> => {
    const response = await api.get('/gofrugal-logs', { params });
    return response.data;
};

export const deleteGoFrugalLog = async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/gofrugal-logs/${id}`);
    return response.data;
};
